module.exports = __webpack_public_path__ + "static/media/22ESCWA16.184db411.jpg";